import { inferAdditionalFields } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/vue'

import type { auth } from '~~/server/auth'

// No baseURL on purpose. This module is evaluated in the server bundle too — the
// global auth middleware imports it, and /kiosk/menu is server-rendered — so
// reading window.location.origin here crashes SSR. Better Auth's own getBaseURL()
// resolves window.location.origin + basePath in the browser (identical to passing
// it), and falls back to the relative '/api/auth' on the server, where nothing
// calls it: the middleware returns early for public /kiosk paths.
export const useAuthClient = createAuthClient({
  plugins: [inferAdditionalFields<typeof auth>()],
})

export const { useSession, signIn, signOut } = useAuthClient
